// extracted by mini-css-extract-plugin
export default {"socialIconList":"SocialLinksList_socialIconList__3H1Hh","socialIconLink":"SocialLinksList_socialIconLink__KKI3v","socialIcon":"SocialLinksList_socialIcon__LV734"};